import React from "react";

export const TrafficIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="#F3F3F4"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 75.484 75.485"
    {...props}
  >
    <g>
      <path
        d="M32.711,10.901c0,0.608,0.111,1.185,0.272,1.741c-0.54-0.872-0.867-1.888-0.867-2.987c0-3.144,2.549-5.69,5.69-5.69
		c1.101,0,2.122,0.327,2.988,0.867c-0.557-0.16-1.13-0.271-1.738-0.271C35.551,4.558,32.711,7.395,32.711,10.901z M39.055,25.437
		c0.606,0,1.182,0.113,1.738,0.274c-0.871-0.54-1.888-0.867-2.988-0.867c-3.141,0-5.69,2.545-5.69,5.69
		c0,1.102,0.327,2.118,0.867,2.987c-0.159-0.556-0.272-1.133-0.272-1.74C32.711,28.278,35.551,25.437,39.055,25.437z M28.154,41.761
		H47.33v19.175h-8.42v2.998h1.168v11.551h-4.672V63.934h1.168v-2.998h-8.42V41.761z M31.029,51.351c0,3.707,3.006,6.711,6.713,6.711
		c3.708,0,6.714-3.004,6.714-6.711s-3.006-6.711-6.714-6.711C34.035,44.64,31.029,47.644,31.029,51.351z M26.836,36.82V24.115
		h-6.952L26.836,36.82z M26.836,15.94V3.236h-6.952L26.836,15.94z M48.649,3.236V15.94L55.6,3.236H48.649z M26.836,57.702V44.997
		h-6.952L26.836,57.702z M28.154,20.883H47.33v19.175H28.154V20.883z M31.029,30.468c0,3.708,3.006,6.713,6.713,6.713
		c3.708,0,6.714-3.003,6.714-6.713c0-3.707-3.006-6.71-6.714-6.71C34.035,23.758,31.029,26.761,31.029,30.468z M48.649,57.702
		l6.95-12.705h-6.95V57.702z M28.154,0H47.33v19.174H28.154V0z M31.029,9.589c0,3.707,3.006,6.71,6.713,6.71
		c3.708,0,6.714-3.003,6.714-6.71c0-3.708-3.006-6.713-6.714-6.713C34.035,2.876,31.029,5.879,31.029,9.589z M48.649,36.82
		l6.95-12.705h-6.95V36.82z M39.055,46.319c0.606,0,1.182,0.112,1.738,0.274c-0.871-0.539-1.888-0.867-2.988-0.867
		c-3.141,0-5.69,2.546-5.69,5.689c0,1.104,0.327,2.119,0.867,2.988c-0.159-0.557-0.272-1.132-0.272-1.738
		C32.711,49.162,35.551,46.319,39.055,46.319z"
      />
    </g>
  </svg>
);
